import React from 'react';

export default function ComingSoon() {
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-6" data-testid="coming-soon">
      <div className="text-center max-w-lg">
        <div className="w-20 h-20 mx-auto mb-8 rounded-2xl bg-sky-500/10 flex items-center justify-center">
          <svg className="w-10 h-10 text-sky-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5a17.92 17.92 0 01-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
          </svg>
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          Na tomto webu pracujeme
        </h1>
        <p className="text-lg text-slate-400 mb-8 leading-relaxed">
          Brzy zde bude novy obsah. Dekujeme za vasi trpelivost.
        </p>
        <div className="inline-flex items-center gap-2 text-sm text-slate-500 bg-slate-800 px-4 py-2 rounded-full">
          <div className="w-2 h-2 rounded-full bg-sky-400 animate-pulse" />
          Pripravujeme pro vas neco skveleho
        </div>
      </div>
    </div>
  );
}
